"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_2 = tslib_1.__importStar(require("react"));
var SingleWatcher_1 = require("./SingleWatcher");
var getWorkspaceRefClient_1 = require("../../functions/utilities/ref/get/getWorkspaceRefClient");
var firestore_1 = require("firebase/firestore");
var react_redux_1 = require("react-redux");
var envConfigBase_1 = require("../../envConfig/envConfigBase");
var description = 'WorkspaceWatcher';
exports.WorkspaceWatcher = (0, react_2.memo)(function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var workspaceId = (0, react_redux_1.useSelector)(function (state) {
        return state.currentWorkspaceId || '';
    });
    var refCallback = (0, react_1.useCallback)(function () {
        return (0, getWorkspaceRefClient_1.getWorkspaceRefClient)({
            firestore: (0, firestore_1.getFirestore)(),
            workspaceId: workspaceId,
        });
    }, [workspaceId]);
    var onNextCallback = (0, react_1.useCallback)(function (docSnapshot) {
        var _a;
        var workspace = docSnapshot.data();
        if (workspace) {
            dispatch({
                type: 'GET_WORKSPACES_SUCCESS', // need this so that it shows up in list
                description: description,
                successValues: {
                    items: (_a = {},
                        _a[docSnapshot.id] = {
                            data: workspace,
                        },
                        _a),
                },
            });
            dispatch({
                type: 'SET_CURRENT_WORKSPACE_ACTION',
                description: description,
                workspace: workspace,
            });
            if ((0, envConfigBase_1.envConfigBase)().enableWorkspaceLogo) {
                // this is most likely broken and will need to be fixed
                dispatch({
                    type: 'GET_WORKSPACE_LOGO_URL_REQUEST',
                    description: description,
                    requestValues: {
                        workspaceId: docSnapshot.id,
                    },
                });
            }
        }
    }, [dispatch]);
    var clearWorkspaceScope = (0, react_1.useCallback)(function () {
        dispatch({
            type: 'CLEAR_WORKSPACE_SCOPE',
            description: description,
        });
    }, [dispatch]);
    var watcherKey = 'workspace';
    if (!workspaceId) {
        return null;
    }
    return (react_2.default.createElement(SingleWatcher_1.SingleWatcher, { onNext: onNextCallback, getRef: refCallback, onUnsubscribe: clearWorkspaceScope, watcherKey: watcherKey }));
});
